export const IntersectingEntityFragment = gql`
  fragment IntersectingEntityFragment on Entity {
    id
    name
    activeConditionCount
    propertyOwnerField {
      ...EntityFieldFragment
    }
    propertyOwnerAddressField {
      ...EntityFieldFragment
    }
    uuid
    layer {
      type
      uuid
    }
  }
`

export const UniversalSearchEntityFragment = gql`
  fragment UniversalSearchEntityFragment on Entity {
    id
    name
    uuid
    activeConditionCount
    layer {
      id
      type
      uuid
      name
    }
    addressDisplayName
  }
`

export const PublicRecordOverviewFragment = gql`
  fragment PublicRecordOverviewFragment on Record {
    ...RecordFragmentOverview
    isPublic
  }
`
